import {Component, ViewEncapsulation} from '@angular/core';
import {UserService} from './user.service';
import {Router} from '@angular/router';
import {AppSettingsService} from './app-settings.service';
import {ToastsManager} from 'ng2-toastr';
import {ViewContainerRef} from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {
  title = 'Pysix Cloud';

  isHeaderHidden = false;

  constructor(private userService: UserService, private router: Router, private ass: AppSettingsService,
              private toastr: ToastsManager, vRef: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vRef);

    ass.headerState.subscribe((headerState: boolean) => {
      this.isHeaderHidden = !headerState;
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/app.component.ts